import { render } from "./ExhibitionSchedule.vue?vue&type=template&id=1bdda6b2&scoped=true"
import script from "./ExhibitionSchedule.vue?vue&type=script&lang=js"
export * from "./ExhibitionSchedule.vue?vue&type=script&lang=js"

import "./ExhibitionSchedule.vue?vue&type=style&index=0&id=1bdda6b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdda6b2"]])

export default __exports__